import React from 'react';
import { withTranslation } from 'react-i18next';


class Footer extends React.PureComponent {

    state = {
       
    }
  
    render() {
        const currentYear = new Date().getFullYear();
        const humanum=process.env.REACT_APP_API_BASE==="http://lexicoscope.huma-num.fr/lexicoscope_2.0/api"? this.props.t('thanksToHumanum'):"";

        return (
            <footer className="bp3-text-small center-text margin-top-3-rem padding-bottom-1-rem">
                (cc) 2016-{currentYear} Université Grenoble Alpes { humanum } - Optimized for Firefox
                { humanum &&
                    <><br/><br/><img alt="https://www.huma-num.fr" src="https://www.huma-num.fr/wp-content/uploads/2020/09/Logo-Huma-Num.png"></img></>
                }
            </footer>
        );
    }

}

Footer.propTypes = {
   
};
  
export default withTranslation()(Footer);